import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import * as React from 'react';
import styled from 'styled-components';
import { Stars } from '@ifixit/toolbox';
import { color, space } from '@core-ds/primitives';
import { _js } from '@ifixit/localize';
var RatingContainer = styled.a(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n   display: flex;\n   align-items: center;\n   padding: ", " 0;\n   cursor: pointer;\n   color: inherit;\n   text-decoration: none !important;\n"])), space[3]);
var ReviewsCount = styled.h4(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n   margin: 0 ", ";\n   font-size: 14px;\n   font-weight: normal;\n   color: inherit;\n"])), space[2]);

var ReviewStars = function ReviewStars(_ref) {
  var numReviews = _ref.numReviews,
      average = _ref.average,
      starSize = _ref.starSize;
  return /*#__PURE__*/React.createElement(RatingContainer, {
    href: "#productReviews",
    numReviews: numReviews
  }, /*#__PURE__*/React.createElement(Stars, {
    rating: average,
    size: starSize,
    activeColor: color.lightBlue[600]
  }), /*#__PURE__*/React.createElement(ReviewsCount, null, numReviews || '', ' ', numReviews === 1 ? _js('review') : numReviews === 0 ? _js('No reviews yet') : _js('reviews')));
};

export default ReviewStars;